import axios from 'axios'
import { errorHandler } from '@/api/error-handler'

const BASE_URL = '/users'

export default {
  getCurrent: params => axios.get(`${BASE_URL}/current`, { params: params })
    .then(response => response.data)
    .catch(errorHandler),

  getFavoriteProducts: (params, errorHandling = false) => axios.get(`${BASE_URL}/current/favoriteproducts`, { params: params })
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  getFavoriteSubstances: (params, errorHandling = false) => axios.get(`${BASE_URL}/current/favoritesubstances`, { params: params })
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  addFavoriteProduct: (params, errorHandling = false) => axios.post(`${BASE_URL}/current/favoriteproducts`, params)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  addFavoriteSubstance: (params, errorHandling = false) => axios.post(`${BASE_URL}/current/favoritesubstances`, params)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  removeFavoriteProduct: (id, errorHandling = false) => axios.delete(`${BASE_URL}/current/favoriteproducts/${id}`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  removeFavoriteSubstance: (id, errorHandling = false) => axios.delete(`${BASE_URL}/current/favoritesubstances/${id}`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  seenFavoriteProduct: (id, errorHandling = false) => axios.get(`${BASE_URL}/current/favoriteproducts/${id}/seen`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  seenFavoriteSubstance: (id, errorHandling = false) => axios.get(`${BASE_URL}/current/favoritesubstances/${id}/seen`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  getAlertsCount: (errorHandling = false) => axios.get(`${BASE_URL}/current/alerts_count`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  getLastFavorites: (errorHandling = false) => axios.get(`${BASE_URL}/current/last_favorites`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  updateSearch: (search, errorHandling = false) => axios.put(`${BASE_URL}/current/searches/${search.id}`, search)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  addSearch: (params, errorHandling = false) => axios.post(`${BASE_URL}/current/searches`, params)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  removeSearch: (id, errorHandling = false) => axios.delete(`${BASE_URL}/current/searches/${id}`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  getSearches: (errorHandling = false) => axios.get(`${BASE_URL}/current/searches`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),
  
  getlastSearches: (errorHandler = false) => axios.get(`${BASE_URL}/current/last_searches`)
    .then(response => response.data)
    .catch(errorHandler),

  createUser: (params, errorHandling = false) => axios.post(`${BASE_URL}`, params)
    .then(response => response.data),

  trialOffer: (errorHandling = false) => axios.post(`${BASE_URL}/current/trial`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

}
